
/**
 * DEV默认只传递更新值，这对系统是不够的，要求传入旧值+新值，在Updating事件中使用该补丁
 */
export function updatePack(event: any) {
    event.newData = Object.assign({}, event.oldData, event.newData)
}